import script from "./anchor.vue?vue&type=script&setup=true&lang=ts"
export * from "./anchor.vue?vue&type=script&setup=true&lang=ts"

import "./anchor.vue?vue&type=style&index=0&id=77a3d7ef&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a3d7ef"]])

export default __exports__